
const PROMINENT_LIMIT = 12

export default {
  name: 'SearchVehicleResults',
  props: {
    vehicles: {
      type: Array,
      required: true,
    },
    prominent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  computed: {
    visibleVehicles() {
      return this.expanded
        ? this.vehicles
        : this.vehicles.slice(0, PROMINENT_LIMIT)
    },
    hiddenCount() {
      return this.vehicles.length - this.visibleVehicles.length
    },
  },
  watch: {
    vehicles() {
      this.expanded = false
    },
  },
  methods: {
    vehiclePath(vehicle) {
      return this.localePath({
        name: 'recherche-led-accessoires-brand-type-typeid',
        params: {
          brand: this.$slugify(vehicle.brand.name).toLowerCase(),
          type: this.$slugify(vehicle.name).toLowerCase(),
          typeid: vehicle.id,
        },
      })
    },
    vehicleLabel(vehicle) {
      return `${vehicle.brand.name} ${vehicle.name}`
    },
    vehicleYears(vehicle) {
      if (!vehicle.year_from || !vehicle.year_to) return null
      return `${vehicle.year_from} - ${vehicle.year_to}`
    },
    vehicleImage(vehicle, width, height) {
      if (vehicle.image) {
        return this.$cropUrl(
          vehicle.image,
          width,
          height,
          vehicle.image.extension
        )
      }
      if (vehicle.brand && vehicle.brand.image) {
        return this.$cropUrl(
          vehicle.brand.image,
          height,
          height,
          vehicle.brand.image.extension
        )
      }
      return null
    },
  },
}
